export { default } from './isMindate'
